<template>
  <Head title="Home" />
  
  <AppLayout>
    <div class="container-fluid">
      <div v-if="!user.agency_id && user.user_type === 'admin'" class="row justify-content-center mx-4">
        <div class="col p-0">
          <admin-landing></admin-landing>
        </div>
      </div>
      
      <div v-if="user.agency_id" class="row justify-content-center mx-4">
        <div class="col p-0">
          <agency-clients-home-table 
            :clients="clients" 
            :user="user" 
            :customization="customization"
          ></agency-clients-home-table>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../Layouts/AppLayout.vue';
import { computed } from 'vue';

const props = defineProps({
  clients: {
    type: Array,
    required: true
  },
  customization: {
    type: Object,
    default: null
  },
  auth: {
    type: Object,
    required: true
  }
});

const user = computed(() => props.auth.user);
</script>
